import * as React from "react";
import styled from "@mui/material/styles/styled";
import { NextStepByDiseaseInfo } from "../nextStep/NextStepByDiseaseInfo";
import { ClinicalReasoningTooltip } from "./ClinicalReasoningTooltip";
import { DesktopOnly } from "../util/desktopOnly";
import { Suggestion } from "../hooks/useSuggestions";
import { Qualifier } from "fe-common/graphql";
import { useFindingClinicalReason } from "../refineFeature/useFindingClinicalReason";

//region [[ Styles ]]

const ClinicalReasoningIconDesktopView = styled("div")(({ theme }) => ({}));

const AutoWidthDesktopOnly = styled(DesktopOnly)({
  width: "auto",
});

const ClinicalReasoningIcon = styled("div")({
  padding: "7px",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicalReasoningIconDesktopProps {
  suggestion: Suggestion;
  qualifier?: Qualifier;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicalReasoningIconDesktop = ({
  ...props
}: ClinicalReasoningIconDesktopProps) => {
  const diseasesStrength = useFindingClinicalReason(
    props.suggestion?.causedByDisease,
  )(props.qualifier ? props.qualifier : null);

  if (!diseasesStrength || diseasesStrength.length === 0) {
    return <></>;
  }

  return (
    <ClinicalReasoningIconDesktopView>
      <ClinicalReasoningIcon className={"clinical-reasoning-icon"}>
        <AutoWidthDesktopOnly>
          <NextStepByDiseaseInfo
            title={
              <ClinicalReasoningTooltip
                show={true}
                suggestion={props.suggestion}
                qualifier={props.qualifier}
              />
            }
          />
        </AutoWidthDesktopOnly>
      </ClinicalReasoningIcon>
    </ClinicalReasoningIconDesktopView>
  );
};
